import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { GenericEvents } from "@newrelic/browser-agent/features/generic_events";
import { env } from "@/env";

let nrAgent: BrowserAgent | undefined; // Make nrAgent accessible in other files`

export const initNewRelic = () => {
	const options = {
		init: {
			session_replay: {
				enabled: true,
				block_selector: "",
				mask_text_selector: "*",
				sampling_rate: 10.0,
				error_sampling_rate: 100.0,
				mask_all_inputs: true,
				collect_fonts: true,
				inline_images: false,
				inline_stylesheet: true,
				mask_input_options: {},
			},
			distributed_tracing: {
				enabled: true,
				cors_use_newrelic_header: true,
				cors_use_tracecontext_headers: true,
				allowed_origins: ["https://prod.rest.stagehub.com", "https://dev.rest.stagehub.io"],
			},
			privacy: { cookies_enabled: true },
			ajax: {
				deny_list: ["bam.nr-data.net", "api.openreplay.com", "api.segment.io", "us.i.posthog.com", "pub.highlight.io", "heapanalytics.com", "o98448.ingest.sentry.io"],
			},
		},
		info: {
			beacon: "bam.nr-data.net",
			errorBeacon: "bam.nr-data.net",
			licenseKey: "NRBR-564d51712f25cf8e45f",
			applicationID: env.NEWRELIC || "",
			sa: 1,
		},
		loader_config: {
			accountID: "3290971",
			trustKey: "3290971",
			agentID: env.NEWRELIC || "",
			licenseKey: "NRBR-564d51712f25cf8e45f",
			applicationID: env.NEWRELIC || "",
		},
		features: [GenericEvents],
	};

	nrAgent = new BrowserAgent(options);
	return nrAgent; // Exported BrowserAgent instance
};

export { nrAgent };
